import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

@Injectable()
export class EnvService {
  private _production: boolean;
  private _apiBaseUrl: string;

  constructor() {
    this._production = environment.production;
    this._apiBaseUrl = `https://us-central1-${environment.projectId}.cloudfunctions.net/api`;
    // this._apiBaseUrl = 'http://localhost:5001/nextstep-dev/us-central1/api';
  }

  apiBaseUrl() {
    return this._apiBaseUrl;
  }

  isProduction() {
    return this._production;
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/core/env.service.ts